import React from 'react';
import logoFull from '../../assets/brand/logo-full.png';
import logoMark from '../../assets/brand/logo-mark.png';

type Variant = 'full' | 'lockup' | 'mark';

// L.A.Cloud brand mark.
//  - 'full'   → the stacked logo image (networked-home cloud + "L.A.Cloud"),
//               best for centered contexts (auth cards, hero) with vertical room.
//  - 'lockup' → the mark beside the wordmark, best for horizontal bars (header/nav).
//  - 'mark'   → just the icon.
export const Brand: React.FC<{ variant?: Variant; height?: number; className?: string }> = ({
  variant = 'lockup',
  height = 30,
  className,
}) => {
  if (variant === 'full') {
    return (
      <img src={logoFull} alt="L.A.Cloud" className={className}
        style={{ height, width: 'auto', display: 'block' }} />
    );
  }
  if (variant === 'mark') {
    return (
      <img src={logoMark} alt="L.A.Cloud" className={className}
        style={{ height, width: 'auto', display: 'block' }} />
    );
  }
  return (
    <span className={className} style={{ display: 'inline-flex', alignItems: 'center', gap: 9 }}>
      <img src={logoMark} alt="" style={{ height, width: 'auto', display: 'block' }} />
      <span style={{ fontFamily: 'var(--sans)', fontWeight: 650, fontSize: Math.round(height * 0.52), letterSpacing: '.005em', whiteSpace: 'nowrap' }}>
        <span style={{ color: 'var(--ivory)' }}>L.A.</span>
        <span style={{ color: 'var(--champ)' }}>Cloud</span>
      </span>
    </span>
  );
};
